export default __webpack_public_path__ + "static/media/2.c30bb8d8.jpg";